import apiClient from "../../api/client";
import Axios from "axios";

export const setupMfa = () => {
  return apiClient.post("/admin/mfa/setup");
};

export const verifyMfaSetup = (token) => {
  return apiClient.post("/admin/mfa/verify-setup", { token });
};

export const verifyMfaLogin = (tempToken, token) => {
  return Axios.post(`${process.env.REACT_APP_BASE_URL}/admin/mfa/verify`, {
    tempToken,
    token,
    isAdmin: true,
  });
};

export const disableMfa = (token) => {
  return apiClient.post("/admin/mfa/disable", { token });
};
